@if (avisos().length > 0) {
  <div class="avisos">
    @for (a of avisos(); track a.id) {
      <!-- Los errores se anuncian con assertive: hay algo que hacer. El resto
           es polite, para no cortar lo que el lector esté leyendo. -->
      <div
        class="aviso"
        [class]="'aviso ' + a.tipo"
        [attr.role]="a.tipo === 'error' ? 'alert' : 'status'"
        [attr.aria-live]="a.tipo === 'error' ? 'assertive' : 'polite'"
        (mouseenter)="frenar(a.id)"
        (mouseleave)="reanudar(a.id)">
        <span class="aviso-icono" aria-hidden="true">
          @if (a.tipo === 'exito') {
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
              <path d="M3.5 8.5l3 3 6-6" stroke="currentColor" stroke-width="2"
                    stroke-linecap="round" stroke-linejoin="round" />
            </svg>
          } @else if (a.tipo === 'error') {
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
              <path d="M8 4.5v4.2" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
              <circle cx="8" cy="11.5" r="1" fill="currentColor" />
              <circle cx="8" cy="8" r="6.2" stroke="currentColor" stroke-width="1.4" />
            </svg>
          } @else {
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
              <path d="M8 7.3v4.2" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
              <circle cx="8" cy="4.6" r="1" fill="currentColor" />
              <circle cx="8" cy="8" r="6.2" stroke="currentColor" stroke-width="1.4" />
            </svg>
          }
        </span>

        <span class="aviso-texto">
          {{ a.texto }}
          @if (a.detalle) {
            <span class="aviso-detalle">{{ a.detalle }}</span>
          }
        </span>

        <button type="button" class="aviso-cerrar" aria-label="Cerrar aviso" (click)="cerrar(a.id)">
          <svg width="12" height="12" viewBox="0 0 12 12" fill="none" aria-hidden="true">
            <path d="M3 3l6 6M9 3l-6 6" stroke="currentColor" stroke-width="1.7"
                  stroke-linecap="round" />
          </svg>
        </button>

        <!-- Cuánto le queda. Sin esto, un aviso que se va solo parece
             desaparecer sin motivo; con la barra se entiende que estaba
             contando, y se ve que pasar el mouse lo frena. -->
        @if (a.duracion > 0) {
          <span class="aviso-tiempo" aria-hidden="true"
                [style.animation-duration.ms]="a.duracion"></span>
        }
      </div>
    }
  </div>
}
